var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBills = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10183_23083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.89543 0 0 0.895431 0 2V18C0 19.1046 0.895431 20 2 20H14C15.1046 20 16 19.1046 16 18V7.82777C16 7.29733 15.7893 6.78863 15.4142 6.41355L9.58645 0.585786C9.21137 0.210714 8.70267 0 8.17223 0H2ZM1.5 2C1.5 1.72386 1.72386 1.5 2 1.5H8V6C8 7.10457 8.89543 8 10 8H14.5V18C14.5 18.2761 14.2761 18.5 14 18.5H2C1.72386 18.5 1.5 18.2761 1.5 18V2ZM13.3793 6.5H10C9.72386 6.5 9.5 6.27614 9.5 6V2.62066L13.3793 6.5Z",
    fill: "#000FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10183_23083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBills, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bills.f75556b5.svg";
export { ForwardRef as ReactComponent };